export interface GetCheckContentRequest {
    /**
     * 任务 ID
     */
    task_id: string;
    /**
     * 章节类型
     */
    chapter_type: string;
}


export interface GetCheckContentIssue {
    /**
     * 问题 ID
     */
    id: string;
    check_field: string;
    check_rule_id: string;
    check_rule_desc: string;
    check_pass: boolean;
    reason: string;
    fix_type: string;
    origin_text: string[];
    depend_field?: string[];
    check_url?: string;
}

export interface GetCheckContentResponse {
    status: 'running' | 'completed';
    /**
     * 段落问题列表
     */
    paragraphs: {
        /**
         * 段落编号
         */
        paragraph_number: string;
        problem_list: GetCheckContentIssue[];
    }[];
}

export const GetCheckContentApi = Symbol.for('GetCheckContentApi');

export interface GetCheckContentApi {
    /**
     * 获取章节内容检查结果
     * @param data 请求参数
     * @param abortSignal 取消信号
     */
    getCheckContent(data: GetCheckContentRequest, abortSignal?: AbortSignal): Promise<GetCheckContentResponse>;
}
